import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Buttons, CancelButton, Currency, Drawer, Stack } from '~/components';
import ReadForm from '~/components/read-only/ReadForm';
import ReadTextbox from '~/components/read-only/ReadTextbox';
import { useApi, useWorkspace } from '~/contexts';
import { useDocumentTitle } from '~/hooks';
import { ErrorPage } from '~/routes/public/pages';

function ViewOpportunityProject({ opportunityId, onClose }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [query, setQuery] = useState({ isReady: false, project: null, error: null });
  const { projectId, parentTab } = useParams();

  const title = 'View Opportunity Project';

  useDocumentTitle(title);

  const fetchData = useCallback(async () => {
    try {
      const { data: project } = await api.www
        .workspaces(workspace.id)
        .opportunities(opportunityId)
        .projects(projectId)
        .get();

      setQuery({ isReady: true, project });
    } catch (error) {
      setQuery({ isReady: true, project: null, error });
    }
  }, [api.www, workspace.id, opportunityId, projectId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  function handleClose() {
    if (onClose) {
      onClose(parentTab);
    }
  }

  const project = query.project;

  if (!query.isReady) return null;
  if (!project) return <ErrorPage.NotFound publicSite={false} />;

  return (
    <Drawer isOpen title={title} onClose={handleClose}>
      {(closeDrawer) => {
        return (
          <Stack>
            <ReadForm.Section title="Opportunity Project Details">
              <ReadForm.Control>
                <ReadTextbox label="Name" value={project.name} />
              </ReadForm.Control>
              <ReadForm.Control>
                <ReadTextbox
                  name="amount"
                  label="Amount"
                  value={
                    <div style={{ textAlign: 'right' }}>
                      <Currency value={project.amount} currency={project.currency} />
                    </div>
                  }
                />
              </ReadForm.Control>
            </ReadForm.Section>

            <Drawer.Actions>
              <Buttons align="right">
                <CancelButton onClick={closeDrawer}>Close</CancelButton>
              </Buttons>
            </Drawer.Actions>
          </Stack>
        );
      }}
    </Drawer>
  );
}
export default ViewOpportunityProject;
